import React from "react";
import styles from "./CheckboxInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import { Form } from "react-bootstrap";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface CheckboxInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

/**
 * CheckboxInput renders a single checkbox input.
 * It supports toggling boolean state, required marker, and layout handling.
 *
 * @component
 * @param {Object} props - Component props
 * @param {FieldProps} props.field - Field configuration
 * @param {(fieldId: string, event: any) => void} props.handleChange - Change handler
 */
const CheckboxInput: React.FC<CheckboxInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    value,
    disabled,
    show = true,
    isValid = true,
    error,
    selected,
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <Form.Check
          type="checkbox"
          id={id}
          checked={!!value}
          disabled={disabled}
          onChange={(e) => handleChange(id, e)}
          onBlur={() => handleBlur(id)}
          onFocus={() => handleSelect(id)}
          isInvalid={!isValid}
          className={`${styles.customCheckInput} ${selected ? CommonStyles.selectedField : ""}`}
        />
        {!isValid && error && (
          <div className="invalid-feedback d-block">{error}</div>
        )}
      </LabeledInputWrapper>
    </div>
  );
};

export default CheckboxInput;
